import { Tokens, TokenUniquenessType } from '~/utils/constants';
import acorn from './acorn.png';
import antidote from './antidote.png';

import axe from './axe.png';
import barrelCommon from './barrelCommon.png';
import barrelUncommon from './barrelUncommon.png';
import bat from './bat.png';
import bed from './bed.png';
import blackPearl from './blackPearl.png';
import bone from './bones.png';
import bottle from './bottle.png';
import brick from './brick.png';

import broom from './broom.png';
import bug from './bugs.png';
import chairCommon from './chairCommon.png';
import chairRare from './chairRare.png';
import chairUncommon from './chairUncommon.png';
import clay from './clay.png';
import coal from './coal.png';
import commonBox from './commonBox.png';
import crystallineOre from './crystalline_ore.png';
import cup from './cup.png';
import deadWater from './deadWater.png';

import doubloon from './doubloon.png';
import earringsCommon from './earringsCommon.png';
import earringsRare from './earringsRare.png';
import earringsUncommon from './earringsUncommon.png';
import floorTile from './floorTile.png';
import flower from './fragrantFlowers.png';
import glass from './glass.png';
import gold from './gold.png';
import goldOre from './goldOre.png';
import greatHut from './GreatHut.jpg';
import hammer from './hammer.png';
import heatinglog from './heatinglogs.png';
import iron from './iron.png';
import ironOre from './ironOre.png';
import largerHut from './LargerHut.jpg';
import leaf from './leaf.png';

import littleHut from './LittleHut.jpg';
import mediumHut from './MediumHut.jpg';
import metalJoin from './metalJoin.png';
import mineral from './minerals.png';
import mushroom from './mushrooms.png';
import nail from './nail.png';
import necklaceCommon from './necklaceCommon.png';
import necklaceRare from './necklaceRare.png';
import necklaceUncommon from './necklaceUncommon.png';
import palladium from './palladium.png';
import palmCommon from './palmCommon.png';
import palmRare from './palmRare.png';
import palmUncommon from './palmUncommon.png';
import pearl from './pearl.png';
import pickaxe from './pickaxe.png';
import platina from './platina.png';
import platinaOre from './platinaOre.png';
import potion from './potion.png';
import rareBox from './rareBox.png';
import redWood from './redwood.png';
import resin from './resin.png';
import rhodium from './rhodium.png';
import ringCommon from './ringCommon.png';
import ringRare from './ringRare.png';
import ringUncommon from './ringUncommon.png';
import roofTile from './roofTile.png';
import root from './roots.png';
import rope from './rope.png';
import sand from './sand.png';
import saw from './saw.png';
import seasonPoints from './seasonPoints.png';
import shiningMetalite from './shining_metallite.png';
import shovel from './shovel.png';
import silver from './silver.png';
import silverOre from './silverOre.png';
import speciousHut from './SpeciousHut.jpg';

import brickHut1 from './stoneHut1.jpg';
import brickHut2 from './stoneHut2.jpg';
import brickHut3 from './stoneHut3.jpg';
import brickHut4 from './stoneHut4.jpg';
import brickHut5 from './stoneHut5.jpg';

import tiledBrickHut1 from './tiledBrickHut1.png';
import tiledBrickHut2 from './tiledBrickHut2.png';
import tiledBrickHut3 from './tiledBrickHut3.png';
import tiledBrickHut4 from './tiledBrickHut4.png';
import tiledBrickHut5 from './tiledBrickHut5.png';

import table from './table.png';
import torch from './torch.png';
import uncommonBox from './uncommonBox.png';
import usdt from './usdt.svg';
import wood from './wood.png';
import woodenPlank from './woodenPlank.png';
import woodenPlateAcorns from './woodenPlateAcorns.png';
import woodenPlateLeaves from './woodenPlateLeaves.png';

const ship1 = 'https://static.pearldivergame.com/staging/output/ships-00.gif';
const ship2 = 'https://static.pearldivergame.com/staging/output/ships-01.gif';
const ship3 = 'https://static.pearldivergame.com/staging/output/ships-02.gif';
const ship4 = 'https://static.pearldivergame.com/staging/output/ships-03.gif';
const ship5 = 'https://static.pearldivergame.com/staging/output/ships-04.gif';
const ship6 = 'https://static.pearldivergame.com/staging/output/ships-05.gif';
const ship7 = 'https://static.pearldivergame.com/staging/output/ships-06.gif';
const ship8 = 'https://static.pearldivergame.com/dev/nft-assets-output/ships-07.gif';
const ship9 = 'https://static.pearldivergame.com/staging/output/ships-08.gif';
const ship10 = 'https://static.pearldivergame.com/staging/output/ships-09.gif';

enum ExtraTokens {
  usdt = 'usdt'
}

enum TokensUniqueness {
  chairs = 'chairs',
  palms = 'palms',
  jewelryBoxes = 'jewelryBoxes',
  barrelsOfRum = 'barrelsOfRum',
  rings = 'rings',
  earrings = 'earrings',
  necklaces = 'necklaces'
}

enum TokensMappings {
  ships = 'ships',
  woodenHuts = 'woodenHuts',
  brickHuts = 'brickHuts',
  tiledBrickHuts = 'tiledBrickHuts'
}

type ComplexToken = { [key: number]: string };

export type TokenIconUniquenessType = Record<TokenUniquenessType, string>;

type TTokenIconValue<K> = K extends Tokens | ExtraTokens
  ? string
  : K extends TokensMappings
    ? string[]
    : TokenIconUniquenessType;

export type TokenIconType = {
  [K in Tokens | ExtraTokens | TokensUniqueness | TokensMappings]: TTokenIconValue<K>;
};

const tokens: TokenIconType = {
  pearl,
  coal,
  gold,
  goldOre,
  iron,
  ironOre,
  palladium,
  platina,
  platinaOre,
  rhodium,
  silver,
  silverOre,
  wood,
  seasonPoints,
  blackPearl,
  usdt,
  nail,
  acorn,
  shiningMetalite,
  crystallineOre,
  heatinglog,
  hammer,
  woodenPlank,
  pickaxe,
  shovel,
  saw,
  bed,
  table,
  broom,
  leaf,
  metalJoin,
  glass,
  brick,
  clay,
  sand,
  roofTile,
  floorTile,
  bottle,
  cup,
  axe,
  rope,
  torch,
  resin,
  mushroom,
  root,
  flower,
  redWood,
  mineral,
  bug,
  bat,
  deadWater,
  bone,
  potion,
  antidote,
  doubloon,

  ships: [ship1, ship2, ship3, ship4, ship5, ship6, ship7, ship8, ship9, ship10],
  woodenHuts: [littleHut, mediumHut, largerHut, greatHut, speciousHut],
  brickHuts: [brickHut1, brickHut2, brickHut3, brickHut4, brickHut5],
  tiledBrickHuts: [tiledBrickHut1, tiledBrickHut2, tiledBrickHut3, tiledBrickHut4, tiledBrickHut5],
  palms: {
    common: palmCommon,
    uncommon: palmUncommon,
    rare: palmRare
  },
  chairs: {
    common: chairCommon,
    uncommon: chairUncommon,
    rare: chairRare
  },
  jewelryBoxes: {
    common: commonBox,
    uncommon: uncommonBox,
    rare: rareBox
  },
  barrelsOfRum: {
    common: barrelCommon,
    uncommon: barrelUncommon,
    rare: ''
  },
  rings: {
    common: ringCommon,
    uncommon: ringUncommon,
    rare: ringRare
  },
  earrings: {
    common: earringsCommon,
    uncommon: earringsUncommon,
    rare: earringsRare
  },
  necklaces: {
    common: necklaceCommon,
    uncommon: necklaceUncommon,
    rare: necklaceRare
  }
};

const complexTokensTestnet: ComplexToken = {
  4: earringsCommon,
  7: earringsUncommon,
  9: earringsRare,
  11: ringCommon,
  12: ringUncommon,
  13: necklaceCommon,
  14: necklaceUncommon,
  15: necklaceRare,
  16: ringRare,
  21: woodenPlateAcorns,
  68: woodenPlateLeaves,
  26: chairCommon,
  27: chairUncommon,
  28: chairRare,
  29: palmCommon,
  30: palmUncommon,
  31: palmRare,
  32: ship1,
  33: ship2,
  34: ship3,
  35: ship4,
  36: ship5,
  37: ship6,
  38: ship7,
  39: ship8,
  40: ship9,
  41: ship10,
  43: commonBox,
  44: uncommonBox,
  45: rareBox,
  46: barrelCommon,
  47: barrelUncommon,
  71: littleHut,
  72: mediumHut,
  73: largerHut,
  74: greatHut,
  75: speciousHut,

  241: tiledBrickHut1,
  242: tiledBrickHut2,
  243: tiledBrickHut3,
  244: tiledBrickHut4,
  245: tiledBrickHut5,

  91: brickHut1,
  92: brickHut2,
  93: brickHut3,
  94: brickHut4,
  95: brickHut5,
  104: woodenPlateLeaves,
  169: earringsCommon,
  170: earringsUncommon,
  171: earringsRare,
  172: ringCommon,
  173: ringUncommon,
  174: ringRare,
  175: necklaceCommon,
  176: necklaceUncommon,
  177: necklaceRare,
  135: woodenPlateAcorns,
  136: woodenPlateLeaves,
  178: chairCommon,
  179: chairUncommon,
  180: chairRare,
  186: palmCommon,
  187: palmUncommon,
  188: palmRare,
  189: ship1,
  190: ship2,
  191: ship3,
  192: ship4,
  193: ship5,
  194: ship6,
  195: ship7,
  196: ship8,
  197: ship9,
  198: ship10,
  181: commonBox,
  182: uncommonBox,
  183: rareBox,
  184: barrelCommon,
  185: barrelUncommon,
  199: earringsCommon,
  200: earringsUncommon,
  201: earringsRare,
  202: ringCommon,
  203: ringUncommon,
  204: ringRare,
  205: necklaceCommon,
  206: necklaceUncommon,
  207: necklaceRare,
  208: commonBox,
  209: uncommonBox,
  210: rareBox,
  211: barrelCommon,
  212: barrelUncommon,
  213: palmCommon,
  214: palmUncommon,
  215: palmRare,
  216: ship1,
  217: ship2,
  218: ship3,
  219: ship4,
  220: ship5,
  221: ship6,
  222: ship7,
  223: ship8,
  224: ship9,
  225: ship10,
  227: earringsCommon,
  228: earringsUncommon,
  229: earringsRare,
  230: ringCommon,
  231: ringUncommon,
  232: ringRare,
  233: necklaceCommon,
  234: necklaceUncommon,
  235: necklaceRare,
  236: commonBox,
  237: uncommonBox,
  238: rareBox,
  239: barrelCommon,
  240: barrelUncommon
};

const complexTokensDemo: ComplexToken = {
  61: earringsCommon,
  62: earringsUncommon,
  63: earringsRare,
  64: ringCommon,
  65: ringUncommon,
  66: ringRare,
  67: necklaceCommon,
  68: necklaceUncommon,
  69: necklaceRare,
  70: chairCommon,
  71: chairUncommon,
  72: chairRare,
  73: commonBox,
  74: uncommonBox,
  75: rareBox,
  76: barrelCommon,
  77: barrelUncommon,
  78: littleHut,
  79: mediumHut,
  80: largerHut,
  81: speciousHut,
  82: greatHut,
  83: brickHut1,
  84: brickHut2,
  85: brickHut3,
  86: brickHut4,
  87: brickHut5,
  88: tiledBrickHut1,
  89: tiledBrickHut2,
  90: tiledBrickHut3,
  91: tiledBrickHut4,
  92: tiledBrickHut5
};

const complexTokensMainnet: ComplexToken = {
  1: earringsCommon,
  2: earringsUncommon,
  3: ringCommon,
  4: ringUncommon,
  5: necklaceCommon,
  6: necklaceUncommon,
  7: earringsRare,
  8: ringRare,
  9: necklaceRare,
  16: chairCommon,
  17: chairUncommon,
  18: chairRare,
  19: palmCommon,
  20: palmUncommon,
  21: palmRare,
  22: ship1,
  23: ship2,
  24: ship3,
  25: ship4,
  26: ship5,
  27: ship6,
  28: ship7,
  29: ship8,
  30: ship9,
  31: ship10,
  32: woodenPlateAcorns,
  34: commonBox,
  35: uncommonBox,
  36: rareBox,
  37: barrelCommon,
  38: barrelUncommon,
  55: littleHut,
  56: mediumHut,
  57: largerHut,
  58: greatHut,
  59: speciousHut,
  52: woodenPlateLeaves,
  73: brickHut1,
  74: brickHut2,
  75: brickHut3,
  76: brickHut4,
  77: brickHut5,

  241: tiledBrickHut1,
  242: tiledBrickHut2,
  243: tiledBrickHut3,
  244: tiledBrickHut4,
  245: tiledBrickHut5,

  85: woodenPlateLeaves,
  169: earringsCommon,
  170: earringsUncommon,
  171: earringsRare,
  172: ringCommon,
  173: ringUncommon,
  174: ringRare,
  175: necklaceCommon,
  176: necklaceUncommon,
  177: necklaceRare,
  135: woodenPlateAcorns,
  136: woodenPlateLeaves,
  178: chairCommon,
  179: chairUncommon,
  180: chairRare,
  186: palmCommon,
  187: palmUncommon,
  188: palmRare,
  189: ship1,
  190: ship2,
  191: ship3,
  192: ship4,
  193: ship5,
  194: ship6,
  195: ship7,
  196: ship8,
  197: ship9,
  198: ship10,
  181: commonBox,
  182: uncommonBox,
  183: rareBox,
  184: barrelCommon,
  185: barrelUncommon,
  199: earringsCommon,
  200: earringsUncommon,
  201: earringsRare,
  202: ringCommon,
  203: ringUncommon,
  204: ringRare,
  205: necklaceCommon,
  206: necklaceUncommon,
  207: necklaceRare,
  208: commonBox,
  209: uncommonBox,
  210: rareBox,
  211: barrelCommon,
  212: barrelUncommon,
  213: palmCommon,
  214: palmUncommon,
  215: palmRare,
  216: ship1,
  217: ship2,
  218: ship3,
  219: ship4,
  220: ship5,
  221: ship6,
  222: ship7,
  223: ship8,
  224: ship9,
  225: ship10,
  227: earringsCommon,
  228: earringsUncommon,
  229: earringsRare,
  230: ringCommon,
  231: ringUncommon,
  232: ringRare,
  233: necklaceCommon,
  234: necklaceUncommon,
  235: necklaceRare,
  236: commonBox,
  237: uncommonBox,
  238: rareBox,
  239: barrelCommon,
  240: barrelUncommon
};

export default tokens;
export { type ComplexToken, complexTokensTestnet, complexTokensDemo, complexTokensMainnet };
